export default "__VITE_ASSET__792dd8a6__"